import { Frame1e7t2kcdb3wu7 as Frame } from '../views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../views/helpers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../views/direct/LinearLayouts.commonHtml.mjs';
import {
  h12aidul0n4qlwh as h1,
  text189ciz0cnr32o as text,
} from '../views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Direct1onk7bpgb7kpa as Direct } from './Page.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  firstOrNull175qkyx53x0vd as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { LogRoot_getInstancecn9b38zgmoxq as LogRoot_getInstance } from '../debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart1mkod6gyztuyy as trimStart,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Routes$_init_$lambda_pz5l6p($this$Direct) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())($this$Direct.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$Direct.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  h1(element_0, 'Not Found');
  text(element_0, "Sorry, we couldn't find the page you're looking for.");
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$Direct.addChild_2qpft2_k$(element);
  return Unit_instance;
}
var RoutesClass;
function Routes() {
  if (RoutesClass === VOID) {
    class $ {
      constructor(parsers, renderers, fallback) {
        var tmp;
        if (fallback === VOID) {
          tmp = new (Direct())('Not Found', Routes$_init_$lambda_pz5l6p);
        } else {
          tmp = fallback;
        }
        fallback = tmp;
        this.parsers_1 = parsers;
        this.renderers_1 = renderers;
        this.fallback_1 = fallback;
      }
      render_y0xm4o_k$(screen) {
        var tmp0_safe_receiver = this.renderers_1.get_wei43m_k$(getKClassFromExpression(screen));
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(screen);
      }
      parse_l5bwev_k$(path) {
        var tmp;
        try {
          var tmp_0 = asSequence(this.parsers_1);
          tmp = firstOrNull(mapNotNull(tmp_0, (it) => it(path)));
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var e = $p;
            LogRoot_getInstance().warn_e3mr9o_k$(['Encountered exception when parsing route: ' + e.toString()]);
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      parseOrFallback_nkiumm_k$(path) {
        var tmp0_elvis_lhs = this.parse_l5bwev_k$(path);
        return tmp0_elvis_lhs == null ? this.fallback_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'Routes');
    RoutesClass = $;
  }
  return RoutesClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp_0 = emptyList();
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$1 = emptyMap();
        tmp.EMPTY_1 = new (UrlLikePath())(tmp_0, tmp$ret$1);
      }
      fromParts_2kx02e_k$(pathname, search) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = split(pathname, charArrayOf([_Char___init__impl__6a9atx(47)]));
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.add_utx5q5_k$(element);
          }
        }
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination, 10));
        var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$6 = decodeURIComponent(item);
          destination_0.add_utx5q5_k$(tmp$ret$6);
        }
        var tmp = destination_0;
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = split(trimStart(search, charArrayOf([_Char___init__impl__6a9atx(63)])), charArrayOf([_Char___init__impl__6a9atx(38)]));
        // Inline function 'kotlin.collections.filterTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_1.add_utx5q5_k$(element_0);
          }
        }
        // Inline function 'kotlin.collections.associate' call
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_1, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_2 = destination_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(decodeURIComponent(substringBefore(element_1, _Char___init__impl__6a9atx(61))), decodeURIComponent(substringAfter(element_1, _Char___init__impl__6a9atx(61))));
          destination_2.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        return new (UrlLikePath())(tmp, destination_2);
      }
      fromUrlString_j9awpo_k$(url) {
        return this.fromParts_2kx02e_k$(substringBefore(url, _Char___init__impl__6a9atx(63)), substringAfter(url, _Char___init__impl__6a9atx(63), ''));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function UrlLikePath$render$lambda(it) {
  return encodeURIComponent(it);
}
function UrlLikePath$render$lambda_0(it) {
  return encodeURIComponent(it.get_key_18j28a_k$()) + '=' + encodeURIComponent(it.get_value_j01efc_k$());
}
var UrlLikePathClass;
function UrlLikePath() {
  if (UrlLikePathClass === VOID) {
    class $ {
      constructor(segments, parameters) {
        Companion_getInstance();
        this.segments_1 = segments;
        this.parameters_1 = parameters;
      }
      render_fgfjvu_k$() {
        var tmp = joinToString(this.segments_1, '/', VOID, VOID, VOID, VOID, UrlLikePath$render$lambda);
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.parameters_1;
        var tmp_0;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver = tmp_0;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_entries_p20ztl_k$();
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          tmp_1 = joinToString(tmp1_safe_receiver, '&', '?', VOID, VOID, VOID, UrlLikePath$render$lambda_0);
        }
        var tmp2_elvis_lhs = tmp_1;
        return tmp + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
      }
      toString() {
        return 'UrlLikePath(segments=' + toString(this.segments_1) + ', parameters=' + toString(this.parameters_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.segments_1);
        result = imul(result, 31) + hashCode(this.parameters_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UrlLikePath()))
          return false;
        if (!equals(this.segments_1, other.segments_1))
          return false;
        if (!equals(this.parameters_1, other.parameters_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'UrlLikePath');
    UrlLikePathClass = $;
  }
  return UrlLikePathClass;
}
var RouteRenderedClass;
function RouteRendered() {
  if (RouteRenderedClass === VOID) {
    class $ {
      constructor(urlLikePath, listenables) {
        this.urlLikePath_1 = urlLikePath;
        this.listenables_1 = listenables;
      }
      toString() {
        return 'RouteRendered(urlLikePath=' + this.urlLikePath_1.toString() + ', listenables=' + toString(this.listenables_1) + ')';
      }
      hashCode() {
        var result = this.urlLikePath_1.hashCode();
        result = imul(result, 31) + hashCode(this.listenables_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RouteRendered()))
          return false;
        if (!this.urlLikePath_1.equals(other.urlLikePath_1))
          return false;
        if (!equals(this.listenables_1, other.listenables_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RouteRendered');
    RouteRenderedClass = $;
  }
  return RouteRenderedClass;
}
//region block: exports
export {
  RouteRendered as RouteRendered1fij9e8c6nzoq,
  Routes as Routesboifombvgcz7,
  UrlLikePath as UrlLikePath1l4lcedbwd0yq,
  Companion_getInstance as Companion_getInstance1h51zwdsitw8c,
};
//endregion

//# sourceMappingURL=Routes.mjs.map
